import React from "react";
import PropTypes from "prop-types";
import { SwitchButton } from "@learningblocks/shared-components";
import cname from "../AnimationSlider/style.module.scss";

export function SwitchBlock(props) {
  const onToggleSwitch =
    ({ name, value }) =>
    (checked) =>
      props.onToggleSwitch({ name, value, checked });

  const renderSwitch = (comp) => (
    <div key={comp.value} className={cname.switch}>
      <SwitchButton
        className={cname.button}
        value={comp.value}
        checked={comp.checked}
        name={comp.name}
        onChange={onToggleSwitch(comp)}
      />
      <p className={cname.text}>{comp.label}</p>
    </div>
  );

  return (
    <div className={cname.switchBlock}>
      {props.switchButtons.map(renderSwitch)}
    </div>
  );
}

SwitchBlock.propTypes = {
  /**
   * List of Switch Buttons to render
   */
  switchButtons: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * name of switch button
       */
      name: PropTypes.string,
      /**
       * value of switch button
       */
      value: PropTypes.string,
      /**
       * Boolean for checked propperty
       */
      checked: PropTypes.bool,
      /**
       * Label for the Switch option
       */
      label: PropTypes.string,
    })
  ),
  /**
   * Callback for onChange method of Switch
   */
  onToggleSwitch: PropTypes.func,
};

SwitchBlock.deafultProps = {
  switchButtons: [],
};
